export const isValidEmail = value =>
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(
    value
  );

export const isValidPassword = value =>
  /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])([\S\s]{6,})$/i.test(value) && value.length >= 6;
